import { render, staticRenderFns } from "./InstructionStepCard.vue?vue&type=template&id=bb491a9c&scoped=true"
import script from "./InstructionStepCard.vue?vue&type=script&setup=true&lang=js"
export * from "./InstructionStepCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./InstructionStepCard.vue?vue&type=style&index=0&id=bb491a9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb491a9c",
  null
  
)

export default component.exports